<template>
  <div>
    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>
    <Button type="primary" @click="queryGoods">查询</Button>
    <Button type="primary" @click="showAddHostModal">新增主播</Button>

    <Table :columns="columns10" :data="data9"></Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal v-model="detailModal" title="充值详情" width="600">
      <Table :columns="detailColumns" :data="detailData"></Table>
    </Modal>

    <Modal v-model="addHostModal" title="新增主播" @on-ok="addHost">
      <Form :model="newHost" :label-width="80">
        <FormItem label="主播昵称">
          <Input v-model="newHost.username" placeholder="请输入主播昵称"></Input>
        </FormItem>
        <FormItem label="主播key">
          <Input v-model="newHost.keycode" placeholder="请输入主播key"></Input>
        </FormItem>
        <FormItem label="主播用户id">
          <Input v-model="newHost.user_id" placeholder="请输入主播用户id"></Input>
        </FormItem>
        <FormItem label="送币数量">
          <InputNumber v-model="newHost.givecoin" :min="0"></InputNumber>
        </FormItem>
        <FormItem label="返点">
          <InputNumber v-model="newHost.rebate" :min="0" :max="0.99" :step="0.00"></InputNumber>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { bindHostList, editHostStatus, getRechargeDetails, addHost } from "../../api/binduser";

export default {
  data() {
    return {
      searchDate: [],
      data9: [],
      detailModal: false,
      detailData: [],
      current: 1,
      total: 0,
      addHostModal: false,
      newHost: {
        username: '',
        keycode: '',
        user_id: '',
        givecoin: 0,
        rebate: 0
      },
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date && date.getTime() > today.getTime();
        },
      },
      columns10: [
        { title: "录入日期", key: "createtime" },
        { title: "主播名称", key: "username" },
        { title: "主播邀请码", key: "key" },
        { title: "主播用户id", key: "user_id" },
        { title: "送币数量", key: "givecoin" },
        { title: "邀请人数", key: "invitedCount" },
        { title: "邀请玩家充值总和", key: "totalAmount" },
        { title: "返点", key: "rebate" },
        {
          title: "收益",
          render: (h, params) => {
            const total = params.row.totalAmount * params.row.rebate;
            return h("span", total.toFixed(4));
          }
        },
        {
          title: "是否启用",
          key: "nstatus",
          render: (h, params) => {
            return h("span", params.row.nstatus == 0 ? "未启用" : "已启用");
          },
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: { marginRight: "5px" },
                  on: { click: () => this.editStatus(params.row.key, params.row.nstatus) },
                },
                params.row.nstatus == 0 ? "启用" : "禁用"
              ),
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  on: { click: () => this.showDetails(params.row.user_id) },
                },
                "详情"
              ),
            ]);
          },
        },
      ],
      detailColumns: [
        { title: "用户ID", key: "bind_user_id" },
        { title: "充值时间", key: "createtime" },
        { title: "充值金额", key: "amount" },
      ],
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    fetchGoodsData(params = {}) {
      bindHostList(params)
        .then((response) => {
          this.data9 = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    editStatus(key, nstatus) {
      const status = nstatus == 0 ? 1 : 0;
      editHostStatus({ keycode: key, nstatus: status }).then(() => {
        this.queryGoods();
      });
    },
    queryGoods() {
      const [starttime, endtime] = this.searchDate.map(date => this.formatDate(date));
      this.fetchGoodsData({ starttime, endtime});
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, "0"),
        String(date.getDate()).padStart(2, "0"),
      ];
      return `${year}-${month}-${day}`;
    },
    changePage(e) {
      this.current = e;
      this.queryGoods();
    },
    resetFormData() {
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
    showDetails(key) {
      const [starttime, endtime] = this.searchDate.map(date => this.formatDate(date));
       getRechargeDetails({"keycode":key,starttime, endtime})
        .then((response) => {
          this.detailData = response.data;
          this.detailModal = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    showAddHostModal() {
      this.addHostModal = true;
    },
    addHost() {
      addHost(this.newHost)
        .then(() => {
          this.$Message.success('主播添加成功');
          this.queryGoods();
        })
        .catch((error) => {
          console.error(error);
          this.$Message.error('主播添加失败');
        });
    },
  },
};
</script>
